// extracted by mini-css-extract-plugin
module.exports = {"card":"DetailSection_card__2TtJA","scroll-area":"DetailSection_scroll-area__26Af8"};